import "babel-polyfill";
import 'semantic-ui-css/semantic.min.css';
import React from "react";
import ReactDOM from "react-dom";
import {Provider} from "react-redux";
import {applyMiddleware, createStore, compose} from "redux";
import { BrowserRouter as Router , Route } from 'react-router-dom';
import thunk from "redux-thunk";
import Keycloak from "keycloak-js";
import App from './App';
import './index.css'
import coreReducer from "./reducers";
import axios from "axios";
import keycloak from "./keycloak.json"
import HomeApp from "./components/home/HomeApp"
import Reports from "./components/reports/reports"
import './components/home/PagesApp.css';
import './components/home/certilytics.css'
import ErrorPage from "./components/ErrorPage"

const store = createStore(
  coreReducer,
  compose(
    applyMiddleware(thunk),
    window.devToolsExtension ? window.devToolsExtension() : f => f
  )
);

const kcf = keycloak;
const kc = new Keycloak(kcf);

kc.init({
  onLoad: 'check-sso',
  checkLoginIframe: false
})
.then(authenticated => {
  if (authenticated) {
    store.getState().keycloak = kc;
    checkAutoLogout(kc);
    ReactDOM.render(app, document.getElementById("root"));
  } else {
    console.log("Not authenticated, redirecting to login");
    kc.login();
  }
})
.catch(error => {
  console.error("Initialization error:", error);
  ReactDOM.render(<ErrorPage error="Authentication failed" />, document.getElementById("root"));
});

function checkAutoLogout(kc) {
  if (kc) {
    // Check if token expired
    var expired = kc.isTokenExpired();
    
    if (expired === true) {
      console.log("Token expired, logging out");
      kc.logout();
    } else {
      // Calculate time until expiration (in seconds)
      var tokenExpiresInSecs = Math.round(kc.tokenParsed.exp + kc.timeSkew - new Date().getTime() / 1000);
      
      // Set a more aggressive refresh schedule - refresh when 70% of the token lifetime has passed
      var refreshTime = Math.max(tokenExpiresInSecs * 0.7 * 1000, 10000);
      
      console.log(`Token expires in ${tokenExpiresInSecs} seconds, refreshing in ${refreshTime/1000} seconds`);
      
      // Add periodic refresh every 4 minutes to keep session alive
      setTimeout(() => {
        console.log("Proactively refreshing token");
        kc.updateToken(30).then(refreshed => {
          if (refreshed) {
            console.log("Token refreshed successfully");
          } else {
            console.log("Token still valid, no refresh needed");
          }
          // Continue monitoring the token
          checkAutoLogout(kc);
        }).catch(error => {
          console.error("Failed to refresh token", error);
          kc.logout();
        });
      }, Math.min(refreshTime, 240000)); // Refresh at timeout or every 4 minutes, whichever comes first
    }
  }
}

axios.interceptors.request.use(config => {
  config.headers = {...config.headers, ...{
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: 'Bearer ' + kc.token
  }};
  return config;
});

const app = (
  <Provider store={store}>
        <Router>
            <App kc = {kc}>
                <Route exact path="/" component={HomeApp}/>
                <Route exact path="/home" component={HomeApp}/>
                <Route exact path="/reports" component={Reports}/>
            </App>
        </Router>
    </Provider>
);

ReactDOM.render(app, document.getElementById("root"));